import React from "react";
import { View } from "react-native";
import NtModalInputField from "../../../components/NtModalInputField";
import NtOnboardingEditorialSection from "../NtOnboardingEditorialSection";
import NtOnboardingField from "../NtOnboardingField";
import { isValidAlias } from "../../utils/validationUtils";

function NtOnboardingCompanyStep({ company, onChangeCompany, aliasError }) {
  const updateCompany = (patch) =>
    onChangeCompany && onChangeCompany({ ...company, ...patch });

  // Only flag invalid when the user has typed something — empty + untouched
  // fields stay neutral. Local format error takes precedence; otherwise show
  // the availability error surfaced by the controller (alias taken/reserved).
  const aliasInvalid = !!company?.domain_name && !isValidAlias(company.domain_name);
  const aliasFieldError = aliasInvalid
    ? "Use lowercase letters, numbers, dots and hyphens only."
    : aliasError || null;

  return (
    <View>
      <NtOnboardingEditorialSection
        first
        label="Company"
        caption="Your public-facing name and a short alias for the URL."
      >
        <NtModalInputField
          title="Company name *"
          placeholder="Acme Co."
          value={company?.name || ""}
          onChangeText={(name) => updateCompany({ name })}
        />
        <NtOnboardingField
          title="Company alias *"
          placeholder="acme.business.io"
          value={company?.domain_name || ""}
          onChangeText={(domain_name) => updateCompany({ domain_name })}
          error={aliasFieldError}
          footer="A unique short name for your company, used in your URL. Lowercase letters, numbers, dots and hyphens only. This is permanent — it can't be changed after signup."
        />
        <NtModalInputField
          title="Description *"
          placeholder="Company information"
          value={company?.description || ""}
          onChangeText={(description) => updateCompany({ description })}
        />
      </NtOnboardingEditorialSection>
    </View>
  );
}

export default NtOnboardingCompanyStep;
